<template>
  <div style="background-color: #f4f4f4;">
      <div v-if="isShowHistoryMode" class="history-mode">
        <label>近30天歷史對話紀錄</label>
      </div>
      <div v-else  class="current-mode"  @click="setHistoryMode(true)">
        <img src="/static/clock.png" alt="logo" >
        <span>查詢30天內歷史對話</span>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    isShowHistoryMode: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      showUserList: false,
      Onboarding_action: false,
      welcome_title: "",
      welcome_subtitle: "",
      welcome_content: "",
      immediacy_time: 0,
      waitShow: false
    }
  },
  methods: {
    setHistoryMode(show) {
      this.$emit('show-input-bar',show)
    },
  },
  mounted() {}
}
</script>

</script>
<style scoped>

.history-bar:hover {
  background-color: rgba(0, 0, 0, 0.30);
}


.history-mode {
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  height: 26px;
  padding: 4px 16px;
  top: 0;
  margin: 4px;
  box-shadow: none;
  color: white;
  background: rgba(0, 0, 0, 0.30);
  border-radius: 0;
  margin: 0;
  transition: background 1s;
}

.current-mode {
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 4px 16px;
  top: 0;
  gap: 4px;
  margin: 4px;
  box-shadow: 0px 2px 6px 0px rgba(15, 1, 62, 0.09);
  color: rgba(252, 119, 29, 1);
  background: white;
  border-radius: 3px;
  margin: 4px;
  transition: background 1s;
  cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/HistoryBar.vue